import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import HomePage from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import LandlordPage from "@/pages/Landlord";
import BookingPage from "@/pages/Booking";
import ContactPage from "@/pages/Contact";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/landlord-certificates" element={<LandlordPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
